<div class="container mx-auto px-0 py-0">
  <div class="bg-white shadow-md rounded-lg p-6">
    <!-- Simple Header -->
    <div class="mb-6">
      <h1 class="text-2xl font-bold text-gray-900">Impressum</h1>
      <p class="text-gray-600">Angaben gemäß § 5 TMG</p>
    </div>

    <!-- Content -->
    <div>
      <div class="prose prose-lg max-w-none">
          <!-- Company Information -->
          <div class="mb-8">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">Firmeninformationen</h2>
            <div class="bg-gray-50 p-6 rounded-lg">
              <h3 class="text-xl font-semibold text-gray-800 mb-4">Labor C Webengineering GmbH</h3>
              <div class="space-y-2 text-gray-700">
                <p><strong>Geschäftsführung:</strong> Mag. Christian Cech</p>
                <p><strong>Firmenbuchnummer:</strong> FN 123456a</p>
                <p><strong>UID-Nummer:</strong> ATU12345678</p>
                <p><strong>Firmenbuchgericht:</strong> Handelsgericht Wien</p>
              </div>
            </div>
          </div>

          <!-- Contact Information -->
          <div class="mb-8">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">Kontaktdaten</h2>
            <div class="bg-gray-50 p-6 rounded-lg">
              <div class="space-y-2 text-gray-700">
                <p><strong>Adresse:</strong></p>
                <p class="ml-4">Pappenheimgasse 33/10<br>1200 Wien<br>Österreich</p>
                <p class="mt-4"><strong>Telefon:</strong> +43 1 890 39 54</p>
                <p><strong>E-Mail:</strong> <a href="mailto:info&#64;labor-c.net" class="text-blue-600 hover:text-blue-800">info&#64;labor-c.net</a></p>
                <p><strong>Website:</strong> <a href="https://www.labor-c.net" class="text-blue-600 hover:text-blue-800" target="_blank">www.labor-c.net</a></p>
              </div>
            </div>
          </div>

          <!-- Legal Information -->
          <div class="mb-8">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">Rechtliche Hinweise</h2>
            <div class="space-y-4 text-gray-700">
              <div>
                <h3 class="text-lg font-semibold text-gray-800 mb-2">Haftungsausschluss</h3>
                <p>Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.</p>
              </div>
              
              <div>
                <h3 class="text-lg font-semibold text-gray-800 mb-2">Haftung für Links</h3>
                <p>Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.</p>
              </div>

              <div>
                <h3 class="text-lg font-semibold text-gray-800 mb-2">Urheberrecht</h3>
                <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem österreichischen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.</p>
              </div>
            </div>
          </div>

          <!-- EU Dispute Resolution -->
          <div class="mb-8">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">EU-Streitschlichtung</h2>
            <div class="bg-gray-50 p-6 rounded-lg">
              <p class="text-gray-700">Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr/" class="text-blue-600 hover:text-blue-800" target="_blank">https://ec.europa.eu/consumers/odr/</a></p>
              <p class="text-gray-700 mt-2">Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
            </div>
          </div>

          <!-- Consumer Dispute Resolution -->
          <div class="mb-8">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">Verbraucherstreitbeilegung/Universalschlichtungsstelle</h2>
            <div class="bg-gray-50 p-6 rounded-lg">
              <p class="text-gray-700">Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
            </div>
          </div>

          <!-- Last Updated -->
          <div class="text-sm text-gray-500 border-t pt-4">
            <p>Stand: Januar 2025</p>
          </div>
      </div>
    </div>
  </div>
</div>
